import { copy } from '../brand';

/** Floating action — minta Nevi analisis */
export function FabRun({
  running,
  onClick,
  disabled,
}: {
  running: boolean;
  onClick: () => void;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      className={`tc-mob-fab tc-mob-fab--eg ${running ? 'tc-mob-fab--running' : ''}`}
      onClick={onClick}
      disabled={disabled || running}
      aria-label={running ? copy.fab.running : copy.fab.idle}
      title={running ? copy.fab.running : copy.fab.idle}
    >
      {running ? (
        <span className="tc-mob-fab__pulse" />
      ) : (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
          <circle cx="12" cy="12" r="3" />
          <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
        </svg>
      )}
    </button>
  );
}
